import { OneActionPlan } from "src/api/client-api/ActionPlan/ActionPlan/useGetOneActionPlan";
import { useCampaigns } from "../Campaigns/useCampaigns";
import { ActionPlanData, APScore } from "./useActionPlanData";
import { PostActionData } from "./context";

type ActionData = {
    actionPlan: OneActionPlan | undefined;
};

export const useActionData = (options: ActionData) => {
    const { actionPlan } = options;

    const { isCampaignBetween } = useCampaigns({
        filterOptions: {
            startFilter: actionPlan?.startSsqPost.campaign,
            endFilter: actionPlan?.endCampaign,
        },
    });

    const getPossibleActionPosts = (plan: ActionPlanData | undefined, includeStart?: boolean): APScore[] => {
        if (plan === undefined) return [];

        const filteredPosts = plan.metadata.scoresWithActionPost.details.filter((post) =>
            isCampaignBetween(post.campaign, true),
        );

        if (includeStart === true) {
            return [plan.metadata.startingPost, ...filteredPosts];
        }

        return filteredPosts;
    };

    const getPostsForAction = (
        plan: ActionPlanData | undefined,
        startCampaign: number | undefined,
        endCampaign: number | undefined,
        includeStart?: boolean,
    ): PostActionData => {
        const allPosts = getPossibleActionPosts(plan, includeStart);
        const foundStartPost = allPosts.find(
            // (post) => post.campaign?.id === action.startSimulationSsqPost.campaign?.id,
            (post) => post.campaign?.id === startCampaign,
        );
        const foundEndPost = allPosts.find(
            // (post) => post.campaign?.id === action.endSimulationSsqPost.campaign?.id
            (post) => post.campaign?.id === endCampaign,
        );

        return { allPosts, foundStartPost, foundEndPost };
    };

    return { getPostsForAction };
};
